.authForm {
  @media (--screen-md-up) {
    display: flex;
    align-items: flex-start;
    gap: 5rem;
  }
}

.description {
  flex: 0 0 27rem;

  @media (--screen-md-up) {
    margin-top: 1.2rem;
  }
}

.subtitle {
  color: var(--color-secondary);
}

.frameContainer {
  position: relative;
  flex: 1 0 36rem;
  height: 60rem;

  @media (--screen-md-up) {
    height: 53rem;
  }

  .loader {
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgb(0, 0, 0, 0.33);
    border-radius: 0.6rem;
  }

  .frame {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    border: none;
    border-radius: 0.6rem;
  }
}
